import React from 'react';
import {
  Button, DataCard, PaymentBlock, PaymentIcon,
} from 'anf-core-react';
import { billingInfoItemProps } from './props';
import { maskCardNumber } from '../../tools/CreditCardHelper/CreditCardHelper';
import { TmntText } from '../Common';

export default function BillingInfoItem({ title, billingInfoItem }) {
  const {
    paymentIcon,
    paymentIconLabel,
    cardNumber,
    cardExpiration,
    paymentType,
    email,
    paymentURL,
    paymentStatus,
    konbiniLocationLabel,
    konbiniPaymentPending,
    konbiniPaymentComplete,
  } = billingInfoItem;

  const cardNumberObscureChar = '\u2022';
  const isPaypalOrVisaCheckout = ['paypal', 'Visa Checkout'].includes(paymentType);
  const isNotAuthorized = paymentStatus === 'AWAIT_AUTH' || paymentStatus === 'AWAIT_PAY_INFO';

  const renderPaymentIcon = (icon, labelText) => (
    <PaymentIcon
      iconName={icon}
      labelText={labelText}
    />
  );

  return (
    <DataCard
      headerTitle={title}
      variant="boxed"
    >
      {paymentIcon !== 'konbini' && (
      <PaymentBlock paymentIcon={renderPaymentIcon(paymentIcon, paymentIconLabel)}>
        {cardNumber && paymentType && (
        <p>{maskCardNumber(paymentIcon, cardNumber, cardNumberObscureChar)}</p>
        )}
        {cardExpiration && (
        <p>{cardExpiration}</p>
        )}
        {isPaypalOrVisaCheckout && email && (
        <p>{email}</p>
        )}
      </PaymentBlock>
      )}
      {/* Display payment status and button for KONBINI payments */}
      {paymentIcon === 'konbini' && konbiniLocationLabel && (
        <>
          <PaymentBlock paymentIcon={renderPaymentIcon(paymentIcon, paymentIconLabel)}>
            <p>
              {isNotAuthorized ? (
                konbiniPaymentPending && <TmntText tmnt={konbiniPaymentPending} />
              ) : (
                konbiniPaymentComplete && <TmntText tmnt={konbiniPaymentComplete} />
              )}
            </p>
          </PaymentBlock>
          <Button
            ariaLabel={konbiniLocationLabel?.value}
            classList="billing-info-kunbini-button"
            variant="tertiary-dark"
            href={isNotAuthorized ? paymentURL : undefined}
            isDisabled={!isNotAuthorized}
            isFullWidth
          >
            <TmntText tmnt={konbiniLocationLabel} />
          </Button>
        </>
      )}
    </DataCard>
  );
}

BillingInfoItem.propTypes = billingInfoItemProps;
